import { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import { haveValue } from "../../../helper/common";
import constants from "../../../Utils/constants";
import LandlordProgressbar from "./LandlordProgressbar";
import { trackClarityEvent } from "../../../Utils/clarityReady";
import { Button } from "../../../components/design";

const PropertyRangeModal = ({
  progressStep,
  setCurrentStep,
  setFormData,
  formData,
}) => {
  const { _t } = useTranslator();
  const cards = [
    {
      id: "1-10",
      range: "1-10",
    },
    {
      id: "11-100",
      range: "11-100",
    },
    {
      id: "101-500",
      range: "101-500",
    },
    {
      id: "501-1000",
      range: "501-1000",
    },
    {
      id: "1001-5000",
      range: "1001-5000",
    },
    {
      id: ">5000",
      range: "> 5000",
    },
  ];
  const [selected, setSelected] = useState(formData.properties_owned);

  const handleNextStep = () => {
    trackClarityEvent("landlord_many_properties_do_you_manage_step_ended");
    setTimeout(() => {
      trackClarityEvent("landlord_how_do_you_want_to_achieve_step_started");
    }, constants.CLARITY_DELAY);
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    if (formData.skor_usage == constants.PERSONAL_USE) {
      setCurrentStep((prev) => prev - 2);
    } else {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleSelectCard = (card_id) => {
    setSelected(card_id);
    setFormData((prev) => ({ ...prev, properties_owned: card_id }));
  };

  return (
    <div>
      <Modal
        show={true}
        // onHide={handleCloseModal}
        centered
        className="landlord-onboarding-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <h4>{_t("howManyPropertiesDoYouManageOwn")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{_t("pleaseSelectAnOption")}</p>
          <LandlordProgressbar step={progressStep + 1} />
          <div className="property-range-cards-comp">
            {cards.map((card) => (
              <div
                onClick={() => handleSelectCard(card.id)}
                className={`usage-card ${
                  selected === card.id ? "select-card " : ""
                }`}
                key={card.id}
              >
                <h3>{card.range}</h3>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="landlord-modal-group-btn">
            <Button variant="secondary" size="lg" onClick={handlePrevStep}>
              {_t("back")}
            </Button>
            <Button
              size="lg"
              onClick={handleNextStep}
              disabled={!haveValue(formData.properties_owned)}
            >
              {_t("next")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PropertyRangeModal;
